import {APIError} from '../core/errors';
import httpClient from '../services/http.service';
import {BASE_URL} from './api-constants';

const _api_base_url = `${BASE_URL}/content/home_page_banner`;

interface bannerResponse {
  images: {
    [key: string]: string;
  };
}

export const getBanners = async (
  storeCode: string | null,
): Promise<bannerResponse> => {
  try {
    let url = _api_base_url;
    //need to remove in pproduction
    url += `?subType=${storeCode ? storeCode : 1234}`;
    const response = await httpClient.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
